<template>
  <div>
    <EmptyMessage v-if="images?.length === 0">
      No media found for the current passage.
    </EmptyMessage>

    <template v-else-if="images">
      <div class="passage-ref">{{ this.passageRef }}</div>
      <MediaList :images="images" @select-image="image => triggerModal({ image: image })" />
      <modal-container />
    </template>
  </div>
</template>
<script>
  import gql from 'graphql-tag';

  import { container as ModalContainer, openModal } from 'jenesius-vue-modal';
  import { DEFAULT_GROUP_KEY } from '@/store/constants';
  import { compareByProperty } from '@/common/sortUtils';
  import EmptyMessage from '@/symphony/widgets/components/EmptyMessage.vue';

  import mixins from '@/mixins';
  import MediaModal from './MediaModal.vue';
  import MediaList from './MediaList.vue';

  export default {
    name: 'MediaWidget',
    mixins: [mixins.InputDataMixin, mixins.RefAdapterMixin],
    components: {
      ModalContainer,
      EmptyMessage,
      MediaList,
    },
    props: {
      doric: {
        inputs: {
          label: 'Media',
          osisRef: {
            value: 'osisRef',
            groupKey: DEFAULT_GROUP_KEY,
          },
          selectedTokenIds: {
            groupKey: DEFAULT_GROUP_KEY,
            value: 'selectedTokenIds',
          },
        },
      },
    },
    data() {
      return {
        passageRef: null,
      };
    },
    watch: {
      usfmRef: {
        handler(newValue) {
          if (newValue) {
            this.passageRef = newValue;
          }
        },
        immediate: true,
      },
      verses(newValue) {
        if (newValue.length) {
          this.passageRef = newValue[0].usfmRef;
        }
      },
    },
    computed: {
      parsedSelectedTokenIds() {
        try {
          return JSON.parse(this.selectedTokenIds);
        } catch (e) {
          return [];
        }
      },
      noSelectedTokenIds() {
        return (
          !Array.isArray(this.parsedSelectedTokenIds) || this.parsedSelectedTokenIds.length === 0
        );
      },
    },
    apollo: {
      images: {
        query: gql`
          query Assets($filters: AssetFilter) {
            assets(filters: $filters) {
              id
              uri
              title
              file
              kind
              collection {
                id
                uri
              }
            }
          }
        `,
        variables() {
          return {
            filters: {
              scriptureReference: {
                // TODO: UBS images have finer scoping
                // than FIA images and maps, similar to Biblica Study Bible
                // vs Tyndale Bible Dictionary.
                usfmRef: this.passageRef,
                scope: 'VERSE',
              },
              kind: { inList: ['MAP', 'PHOTO'] },
            },
          };
        },
        update(data) {
          return (
            data.assets
              // TODO: Add PDF support with appropriate viewer (e.g., pdf.js)
              // For now, filter out PDFs since modal viewer only supports images
              .filter(asset => !asset.file?.toLowerCase().endsWith('.pdf'))
              .map(asset => asset)
              .sort(compareByProperty('title'))
              .sort((a, b) => a.kind.localeCompare(b.kind))
          );
        },
      },
      verses: {
        query: gql`
          query WordTokenVerse($filters: WordTokenFilter) {
            wordTokens(filters: $filters) {
              id
              verse {
                usfmRef
              }
            }
          }
        `,
        variables() {
          return {
            filters: { id: { inList: this.parsedSelectedTokenIds } },
          };
        },
        skip() {
          return this.noSelectedTokenIds;
        },
        update(data) {
          return data.wordTokens.map(token => token.verse);
        },
      },
    },
    methods: {
      triggerModal(props) {
        openModal(MediaModal, props);
      },
    },
  };
</script>
<style type="text/css" scoped>
  .passage-ref {
    margin-bottom: 1em;
  }
</style>
